<template>
  <TaktJournal
    :takt_journal="getTaktJournal"
    :week_days="getWeekDays"
    :project="getProject(project_id)"
    :takt_times="getCalendar(project_id).takt_times"
    :settings="getTaktJournalSettings"
    ref="test"
    >
    <template #list="{takt_journal, week_days}">
      <v-list
        id="report-date-list"
        class="report-date-list pa-0">
        <template v-for="day in takt_journal">
          <v-list-item
            :key="`taktday${day.date}`"
            :id="`list-entry-${day.date}`"
            @click="scrollToDate(day.date)"
            :style="selected_date === day.date.toString()? 'background-color: #616161':''"
          >
          <v-list-item-content>
            <v-list-item-title>
              {{week_days[day.date.getDay()]}} {{day.date.getDate()}}-{{day.date.getMonth()+1&lt;10?0:''}}{{day.date.getMonth()+1}}-{{day.date.getFullYear()}}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{day.workpackages_changed.length}} {{day.workpackages_changed.length === 1?'Entry':'Entries'}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="`taktdaydivider${day.date}`" class="ma-0"></v-divider>
      </template>
      </v-list>
    </template>
    <template #content="{takt_journal, week_days, project}">
      <TaktJournalDay
        v-for="(day, day_index) in takt_journal"
        :key="`day${day.date}`"
        :id="day.date"
        :ref="day.date"
        >
        {{day_index}}
        <template #overview>
          <v-img
            gradient="to top,rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.05),rgba(0, 0, 0, 0.4)"
            :src="project.image"
            width="100%"
            max-height="150px"
            >
              <v-layout class="ml-1" justify-start>
                  <div style="color: white">{{$t('Project.Journal.ExportPdf.SiteJournal')}}</div>
              </v-layout>
          </v-img>
          <TaktJournalDayOverviewContent>
            <template #body>
              <div class="mt-1 mb-1">{{week_days[day.date.getDay()]}} {{day.date.getDate()}}-{{day.date.getMonth()+1&lt;10?0:''}}{{day.date.getMonth()+1}}-{{day.date.getFullYear()}}</div>
            </template>
          </TaktJournalDayOverviewContent>
          <TaktJournalDayOverviewContent>
            <template #body>
              <div class="mt-1 mb-1">{{project.name}}</div>
            </template>
          </TaktJournalDayOverviewContent>
          <TaktJournalDayOverviewContent
            justify_body="center"
            >
            <template #header>
              {{$t('Project.Journal.ExportPdf.Workers')}}
            </template>
            <template #body>
              {{day.workers_on_side}}
            </template>
            <template #work-packages>
              <StandardFlexBox>
                <WorkPackage
                    v-for="(work_package, index) in day.wps_on_side"
                    :key="`on_site_${work_package.id}_${index}`"
                    :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                    :token="work_package.manpower_actual > 0?work_package.manpower_actual:'0'"
                    zoom="0.75"
                  />
              </StandardFlexBox>
            </template>
          </TaktJournalDayOverviewContent>
          <TaktJournalDayOverviewContent
            v-for="content in stati_today"
            :key="`content_${content.text}`"
            >
            <template #header>
              <v-icon size="18" color="black" class="mr-1">{{content.icon}}</v-icon>
              {{content.text}} {{$t('Project.Journal.ExportPdf.Today')}} ({{day[content.prop].length}})
            </template>
            <template #work-packages>
              <StandardFlexBox>
                <WorkPackage
                  v-for="(work_package, index) in day[content.prop]"
                  :key="`${content.text}_${work_package.id}_${index}`"
                  :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                  :token="work_package.token"
                  zoom="0.75"
                />
              </StandardFlexBox>
            </template>
          </TaktJournalDayOverviewContent>
          <TaktJournalDayCommentary v-if="commentary[day_index] || editCommentary">
            <template #header>
              {{$t('Project.Journal.ExportPdf.Workpackage.Commantary')}}:
            </template>
            <template #body>
              <StandardFlexBox>
                <textarea
                  v-if="editCommentary"
                  v-model="commentary[day_index]"
                  style="width: 250px"
                ></textarea>
                <div v-else>
                  {{commentary[day_index]}}
                </div>
              </StandardFlexBox>
            </template>
          </TaktJournalDayCommentary>
        </template>
        <template #content>
          <TaktJournalDayContentEntry
            v-for="work_package in day.workpackages_changed"
            :key="`work_package${work_package.id}`"
            >
            <template #info>
              <WorkPackage
                :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                :token="work_package.token"
                :icon="work_package.icon"
                :zoom="1.0"
                />
              <div>{{work_package.name}}</div>
              <div>{{$t('Project.Journal.ExportPdf.Workpackage.Taktarea')}}: {{work_package.taktarea.name}}</div>
              <div>{{$t('Project.Journal.ExportPdf.Workpackage.Manpower.Title')}}: <br>
                -{{$t('Project.Journal.ExportPdf.Workpackage.Manpower.Planned')}}: {{work_package.manpower_planned}} <br>
                -{{$t('Project.Journal.ExportPdf.Workpackage.Manpower.Actual')}}: {{work_package.manpower_actual}}
              </div>
              <div v-if="show_contact_name">Contact: {{work_package.contact_name}}</div>
            </template>
            <template #body>

              <div v-if="show_status">
              <div>{{$t('Project.Journal.ExportPdf.Workpackage.StatusChanges')}}</div>
              <TaktJournalDayContentEntryRow
                v-for="(status, index) in work_package.status_changed"
                :key="`status_changed_${index}`"
                >
                <v-icon style="min-width: 15px;" size="12" color="black">{{getStatusIcon(status.value)}}</v-icon>
                <div>{{status.updated.substring(11, 16)}}: {{status.value}}</div>
                <v-spacer/>
                <div class="ml-1">[{{status.user}}]</div>
              </TaktJournalDayContentEntryRow>
              </div>

              <div v-if="show_comments">
              <div>{{$t('Project.Journal.ExportPdf.Workpackage.Comments')}}</div>
              <TaktJournalDayContentEntryRow
                v-for="(comment, index) in work_package.comments"
                :key="`comments${index}`"
                >
                <div>  {{comment.updated.substring(11, 16)}}: {{comment.value}}</div>
                <v-spacer/>
                <div class="ml-1">[{{comment.user}}]</div>
              </TaktJournalDayContentEntryRow>
              </div>

              <div v-if="show_steps">
              <div class="journal-header">{{$t('Project.Journal.ExportPdf.Workpackage.Steps')}}</div>
              <TaktJournalDayContentEntryRow
                v-for="(step, index) in work_package.steps_changed"
                :key="`steps_changed${index}`"
                >
                <div v-if="step.action === 'created'">{{step.updated.substring(11, 16)}}: {{step.type}} "{{step.name}}" {{step.action}}</div>
                <div v-else>{{step.updated.substring(11, 16)}}: {{step.type}} "{{step.name}}" {{step.value === '1'?'done':'reopened'}}</div>
                <v-spacer/>
                <div class="ml-1">[{{step.user}}]</div>
              </TaktJournalDayContentEntryRow>
              </div>

              <div v-if="show_images">
              <div class="journal-header">{{$t('Project.Journal.ExportPdf.Workpackage.Images')}}</div>
              <TaktJournalDayContentEntryRow
                v-for="(image, index) in work_package.images_changed"
                :key="`images_changed${index}`"
                >
                <v-img
                  class="mr-1"
                  :src="image.value"
                  height="90px"
                  width="120px"
                  contain
                  />
                <StandardFlexBox
                  direction="column"
                  >
                  <div class="ma-0">{{image.updated.substring(11, 16)}}:</div>
                  <div class="ma-0">"{{image.comment}}"</div>
                  <div class="ma-0">[{{image.user}}]</div>
                  <div class="ma-0" style="font-size: 2mm; word-wrap: break-word">{{image.value}}</div>
                </StandardFlexBox>
              </TaktJournalDayContentEntryRow>
              </div>

              <div v-if="show_other_changes">
              <div>{{$t('Project.Journal.ExportPdf.Workpackage.OtherChanges')}}</div>
              <TaktJournalDayContentEntryRow
                v-for="(change, index) in work_package.other_changes"
                :key="`other_changes${index}`"
                >
                <div>{{change.updated.substring(11, 16)}}: {{change.target}} "{{change.value}}" {{change.action}}</div>
                <v-spacer/>
                <div class="ml-1">[{{change.user}}]</div>
              </TaktJournalDayContentEntryRow>
              </div>

            </template>
          </TaktJournalDayContentEntry>
        </template>
      </TaktJournalDay>
    </template>
    <!-- <template #settings="{settings, takt_times}"> -->
    <template #settings="{settings}">

<!-- requestTaktJournalByDates({project_id: project_id, dates: $event}) -->

<!-- @input="setTaktJournalSettingsDatePicker($event)" -->
<!-- @input=" requestTaktJournalByDates({project_id: project_id, dates: $event})" -->


      <v-date-picker
      multiple
      color="red"
      :value="getTaktJournalSettings.date_picker"
      :locale-first-day-of-year="4"
      first-day-of-week="1"
      scrollable
      :events="getTaktJournalDatePickerEntries"
      event-color="blue lighten-1"
      @input="setCalendar($event)"
      @mousedown.native="settings.select_range && settings.date_picker.length > 1?
              setTaktJournalSettings({date_picker: []}):''"
      >
        <v-layout column>
          <v-layout>
            <v-btn @click="setTaktJournalSettings({select_range: false})" :color="settings.select_range?'':'red'">{{$t('Project.Journal.Settings.SingleDateButton')}}</v-btn>
            <v-btn @click="setTaktJournalSettings({select_range: true})" :color="settings.select_range?'red':''">{{$t('Project.Journal.Settings.RangeDateButton')}}</v-btn>
          </v-layout>
          <v-layout>
            <!-- <v-btn
              @click="setTaktJournalSettings({
                select_range: true,
                date_picker: [],
                }),
              setTaktJournalSettingsDatePicker([
                takt_times[0].dates[0].toISOString().substring(0, 10),
                takt_times[takt_times.length-1].dates[takt_times[takt_times.length-1].dates.length-1].toISOString().substring(0, 10)
                ])"
              >
              Select Project Length
            </v-btn> -->
            <v-btn
              @click="setTaktJournalSettings({date_picker: []})"
              >
              {{$t('Buttons.Reset')}}
            </v-btn>
          </v-layout>
        </v-layout>
      </v-date-picker>

      <v-btn
        @click="setTaktJournalSettings({filter_no_entries: !settings.filter_no_entries})"
        :color="settings.filter_no_entries?'red':''"
        >
        {{$t('Project.Journal.Settings.HideEmptyDatesButton')}}
      </v-btn>
      <div>{{$t('Project.Journal.Settings.Note[0]')}} <br> {{$t('Project.Journal.Settings.Note[1]')}}</div>
      <v-btn
        color="red"
        @click="exportJournal()"
        >
        {{$t('Project.Journal.Settings.ExportButton')}}
      </v-btn>
      <br>
      <v-btn
        color="red"
        @click="editCommentary = !editCommentary"
        >
        {{$t('Project.Journal.Settings.AddCommentButton')}}
      </v-btn>
      <v-checkbox
        v-model="show_status"
        :label="$t('Project.Journal.Settings.ShowStatus[0]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="show_comments"
        :label="$t('Project.Journal.Settings.ShowStatus[1]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="show_steps"
        :label="$t('Project.Journal.Settings.ShowStatus[2]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="show_images"
        :label="$t('Project.Journal.Settings.ShowStatus[3]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="show_other_changes"
        :label="$t('Project.Journal.Settings.ShowStatus[4]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-checkbox
        v-model="show_contact_name"
        :label="$t('Project.Journal.Settings.ShowStatus[5]')"
        color="red"
        hide-details
      ></v-checkbox>
      <v-btn @click="requestTaktJournalByDates({project_id: project_id, dates: getTaktJournalDatePicker,
        show_status: show_status, show_comments: show_comments, show_steps: show_steps,
        show_images: show_images, show_other_changes: show_other_changes
      })">{{$t('Project.Journal.Settings.RefreshDataButton')}}</v-btn>
    </template>
  </TaktJournal>
</template>
<script>
  import store from '@/store/index'

  import { TaktJournalMixin } from '@/mixins/TaktJournal.mixin.js'
  export default {
    components: {
    },
    mixins: [
      TaktJournalMixin
    ],
    computed: {
      project_id() {
        return parseInt(this.$route.params.project_id);
      },
    },
    beforeRouteEnter (to, from, next) {
      store.dispatch('ProjectTaktJournal/requestTaktJournalLastWeek', to.params.project_id).then(() => next());
    },
  }
</script>
<style>
  @page {
  margin: 5mm;
  }
  @media print {
     body {
      margin: 0;
    }
  }
</style>
